<template>
  <div>
    <b-modal :id="'surveyCourses' + survey.id" hide-header-close no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-footer
      modal-class="usersListPendingFull">

      <!-- Custom Header -->
      <template #modal-header>
        <div class="w-100 d-flex justify-content-end align-items-center">
          <i class="fas fa-times close-btn" @click="closeSurveyCourseReport"></i>
        </div>
      </template>


      <SurveyCourseReport :survey_id="survey_id" :groupsWithSubgroupsOptions="groupsWithSubgroupsOptions"
        :selectedGroupSubgroup="selectedGroupSubgroup" :selectedSurveyType="survey.survey_type"
        :coursesOptions="coursesOptions" :getCustomNames="getCustomNames" />
    </b-modal>

    <b-modal :id="'surveyParticipants' + survey.id" hide-header-close no-close-on-backdrop no-close-on-keyboard no-close-on-esc
      hide-footer modal-class="usersListPendingFull">

       <!-- Custom Header -->
      <template #modal-header>
        <div class="w-100 d-flex justify-content-end align-items-center">
          <i class="fas fa-times close-btn" @click="closeSurveyParticipantReport"></i>
        </div>
      </template>

      <SurveyParticipantReport :subgroupId="selectedGroupSubgroup" :selectedSurveyType="survey.survey_type"
        :groupsWithSubgroupsOptions="groupsWithSubgroupsOptions" :survey_id="survey.id" :coursesOptions="coursesOptions"
        :getCustomNames="getCustomNames" @close-report="handleCloseReport" />
    </b-modal>

    <span class="btn p-0 m-0 text-info"
      v-if="['course_exit', 'programme_exit', 'student_feedback'].includes(survey.survey_type)"
      @click="$bvModal.show('downloadCourseExitReportModel' + survey.id)">
      <i class="fas fa-file-alt"></i>
    </span>

    <span class="btn p-0 m-0 text-info" v-if="['alumini', 'employer', 'parent', 'faculty'].includes(survey.survey_type)"
      @click="downloadCourseExitReport(survey.id, survey.name, null, survey.usersubgroup_id)">
      <i class="fas fa-file-alt"></i>
    </span>

    <b-modal :id="'downloadCourseExitReportModel' + survey.id" :title="'Reports for ' + survey.name"
      no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-footer size="lg">
      <div class="selectGroup mb-2 d-flex justify-content-between" v-if="survey.survey_type === 'student_feedback'">
        <p style="font-size: 14px; font-weight: 600">
          Select
          {{ getCustomNames.userGroup.custom_name || "Usergroup" }}
          -
          {{ getCustomNames.userSubgroup.custom_name || "userSubgroup" }}
        </p>

        <b-form-select class="w-100" :options="groupsWithSubgroupsOptions" v-model="selectedGroupSubgroup"
          @change="getSubgroupParticipants"></b-form-select>
      </div>

      <table class="table table-striped table-bordered w-100">
        <tbody>
          <tr v-if="['course_exit', 'programme_exit'].includes(survey.survey_type)">
            <th class="p-2">Survey Report</th>
            <td class="p-2">
              <b-button variant="primary" size="sm" @click="addValue">+ Add Level</b-button>

              <table class="table table-bordered table-striped mt-2">
                <thead class="thead-dark">
                  <tr>
                    <th>Value</th>
                    <th>Comparison</th>
                    <th>Compare By</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(attainment, index) in attainments" :key="index">
                    <td>
                      <b-form-input v-model.number="attainment.value" @keypress="handleNumber"></b-form-input>
                    </td>
                    <td>
                      <b-form-select :options="operators" v-model="attainment.comparison"></b-form-select>
                    </td>
                    <td>
                      <b-form-input v-model.number="attainment.compare_by" @keypress="handleNumber"></b-form-input>
                    </td>
                    <td>
                      <span class="btn p-0 m-0 text-danger" @click="attainments.splice(index, 1)">
                        <i class="fas fa-minus-circle"></i>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>

              <b-button variant="danger" class="mt-3" size="sm"
                @click="downloadCourseExitReport(survey.id, survey.name, survey.course_id, null)">
                Download PDF
              </b-button>
            </td>
          </tr>

          <tr v-if="survey.survey_type === 'student_feedback' && !temporaryTutorOnlypermission">
            <th class="p-2">Instructor Feedback Survey (Single PDF File)</th>
            <td class="text-center">
              <b-button @click="singleorindividual = 'single'; generateReport(survey.id)" variant="danger" size="sm">
                Download
              </b-button>
            </td>
          </tr>

          <tr v-if="survey.survey_type === 'student_feedback' && !temporaryTutorOnlypermission">
            <th class="p-2">Instructor Feedback Survey (Separate Files)</th>
            <td class="text-center">
              <b-button @click="getTeacherFeedbackReport(survey.id)" variant="danger" size="sm">
                Download
              </b-button>
            </td>
          </tr>

          <tr v-if="survey.survey_type === 'student_feedback' && !temporaryTutorOnlypermission">
            <th class="p-2">Instructor Feedback Survey (Consolidated Data)</th>
            <td class="text-center">
              <b-button @click="generateCoursesSummaryReport(survey.id)" variant="danger" size="sm">Download</b-button>
            </td>
          </tr>

          <tr v-if="survey.survey_type === 'student_feedback'">
            <th class="p-2">Individual Participant Sheet</th>
            <td class="text-center">
              <b-button @click="generateIndividualReport(survey.id)" variant="danger" size="sm">Download</b-button>
            </td>
          </tr>

          <tr>
            <th class="p-2">Survey Participants Report</th>
            <td class="p-2 text-center">
              <span class="btn p-0 m-0 text-info font-weight-bolder" @click="getParticipantsReport()">
                View
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </div>
</template>

<script>
import SurveyParticipantReport from "../reports/survey/SurveyParticipantReport.vue";
import SurveyCourseReport from "../reports/survey/SurveyCourseReport.vue";
import acl from "../../../../authorization/acl.js";

export default {
  async created() {
    // these calls can be awaited to ensure initial data is loaded
    await this.temporaryTutorOnlypermissionCheck();
    await this.getGroupList();
    await this.getMyCourses();
  },
  props: ["survey"],
  data() {
    return {
      selectedGroupSubgroup: null,
      students: [],
      groupsWithSubgroupsOptions: [],
      usergroupOptions: [],

      reportType: 0,
      loadSurveyReport: false,
      temporaryTutorOnlypermission: false,
      survey_id: "",
      selectedSurveyType: "",
      participantsReportTitle: null,
      coursesOptions: [],
      singleorindividual: null,

      // to avoid Vue warnings when methods assign these
      questionsChoices: [],
      courseFaculties: {},
      answersCounts: {},

      fetchData: false,

      attainments: [
        { value: 1, comparison: ">=", compare_by: 50 },
        { value: 2, comparison: ">", compare_by: 65 },
        { value: 3, comparison: ">", compare_by: 80 },
      ],
      operators: [
        { value: null, text: "Select Operator" },
        { value: "<", text: "<" },
        { value: ">", text: ">" },
        { value: "<=", text: "<=" },
        { value: ">=", text: ">=" },
      ],
    };
  },
  computed: {
    getCustomNames() {
      return this.$store.getters.getCustomNamings;
    },
  },
  components: {
    SurveyParticipantReport,
    SurveyCourseReport,
  },
  methods: {
    closeSurveyParticipantReport() { this.$bvModal.hide("surveyParticipants" + this.survey.id); },
    closeSurveyCourseReport() { this.$bvModal.hide("surveyCourses" + this.survey.id); },
    handleCloseReport() {
      this.$bvModal.hide("surveyParticipants" + this.survey.id);
    },
    // open modal for separate teacher feedback files
    async getTeacherFeedbackReport(surveyId) {
      this.survey_id = surveyId;
      this.students = [];
      this.questionsChoices = [];
      this.courseFaculties = {};
      this.answersCounts = {};
      // DO NOT reassign this.survey (prop) here — earlier code did `this.survey = {}` which mutates a prop
      this.$bvModal.show("surveyCourses" + this.survey.id);
    },

    handleNumber(event) {
      const keyCode = event.keyCode ? event.keyCode : event.which;
      // allow 0-9 and dot
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        event.preventDefault();
      }
    },

    async temporaryTutorOnlypermissionCheck() {
      const institutionAdmin = await acl.isUserGranted("institutionAdmin");
      if (institutionAdmin) return;
      const groupAdmin = await acl.isUserGranted("groupAdmin");
      if (groupAdmin) return;
      const subgroupAdmin = await acl.isUserGranted("subgroupAdmin");
      if (subgroupAdmin) this.temporaryTutorOnlypermission = true;
      return;
    },

    addValue() {
      this.attainments.push({ value: "", comparison: null, compare_by: "" });
    },

    generateIndividualReport(surveyId) {
      if (this.selectedGroupSubgroup == null) {
        return this.$toast.error("Please select a subgroup!", {
          position: "top",
          duration: 3000,
        });
      }
      this.survey_id = surveyId;
      this.loadSurveyReport = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/studfbsurveys/${surveyId}/participants/answerform/pdfexport?custom_report=${this.reportType}`;
      this.$axios
        .post(
          url,
          {
            usersubgroup: this.selectedGroupSubgroup != null ? this.selectedGroupSubgroup : null,
          },
          { responseType: "blob" }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "individualParticipantSheet.pdf");
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.loadSurveyReport = false;
        })
        .catch(() => {
          this.loadSurveyReport = false;
        });
    },

    async getParticipantsReport() {
      this.$bvModal.show("surveyParticipants" + this.survey.id);
    },

    getMyCourses() {
      const url = this.$store.getters.getAPIKey.mainAPI + `/institutionuser/courses/withusers`;
      this.$axios
        .get(url)
        .then((response) => {
          let courses = response.data;
          this.coursesOptions = [{ value: null, text: "Select Course" }];
          courses.forEach((course) => {
            this.coursesOptions.push({
              value: course.id,
              text: course.name + " (" + course.code + "-" + (course.usersubgroup?.usergroup?.code || "") + "-" + (course.usersubgroup?.code || "") + ")",
            });
          });
        })
        .catch((error) => {
          // keep silent or show toast if desired
          console.error(error);
        });
    },

    async getGroupList() {
      const url = this.$store.getters.getAPIKey.mainAPI + `/institutionuser/usersubgroups`;
      this.$axios
        .get(url)
        .then((response) => {
          const customName = this.getCustomNames && this.getCustomNames.userSubgroup && this.getCustomNames.userSubgroup.custom_name;
          const custom = customName ? `Select ${customName}` : "Select Usersubgroup";

          this.groupsWithSubgroupsOptions = [{ value: null, text: custom, disabled: true }];
          this.usergroupOptions = [{ value: null, text: custom, disabled: true }];

          const groupSubgroup = response.data || [];
          groupSubgroup.forEach((subgroup) => {
            this.groupsWithSubgroupsOptions.push({
              value: subgroup.id,
              text: subgroup.usergroup?.name + " - " + subgroup.name,
            });
            this.usergroupOptions.push({
              value: subgroup.id,
              text: subgroup.usergroup?.name + " - " + subgroup.name,
            });
          });

          // set default to first real option if available
          if (this.groupsWithSubgroupsOptions.length > 1 && !this.selectedGroupSubgroup) {
            this.selectedGroupSubgroup = this.groupsWithSubgroupsOptions[1].value;
          }
        })
        .catch((error) => {
          this.fetchData = false;
          console.error(error);
        });
    },

    generateCoursesSummaryReport(surveyId) {
      if (this.selectedGroupSubgroup == null) {
        return this.$toast.error("Please select a subgroup!", {
          position: "top",
          duration: 3000,
        });
      }
      this.survey_id = surveyId;
      this.loadSurveyReport = true;
      const url = this.$store.getters.getAPIKey.mainAPI + `/studfbsurveys/usersubgroup/coursessummaryreport/pdfexport`;
      this.$axios
        .post(
          url,
          {
            usersubgroup: this.selectedGroupSubgroup,
            studfbsurvey: this.survey_id,
          },
          { responseType: "blob" }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Instructor Feedback Survey (Consolidated Data).pdf");
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.loadSurveyReport = false;
        })
        .catch(() => {
          this.loadSurveyReport = false;
        });
    },

    async downloadCourseExitReport(surveyId, surveyName, courseId, usersubgroupId) {
      // collect valid attainments
      const direct = [];
      this.attainments.forEach((attainment) => {
        if (
          attainment.value !== "" &&
          attainment.comparison != null &&
          attainment.compare_by !== ""
        ) {
          direct.push(attainment);
        }
      });

      const url = this.$store.getters.getAPIKey.mainAPI + `/studfbsurveys/${surveyId}/report/pdfexport`;
      this.loadSurveyReport = true;
      this.$axios
        .post(
          url,
          {
            rubrics: direct,
            course: courseId,
            usersubgroup: usersubgroupId,
          },
          { responseType: "blob" }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", surveyName + ".pdf");
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.loadSurveyReport = false;
        })
        .catch(() => {
          this.loadSurveyReport = false;
        });
    },

    generateReport(surveyId) {
      if (this.selectedGroupSubgroup == null) {
        return this.$toast.error("Please select a subgroup!", {
          position: "top",
          duration: 3000,
        });
      }

      this.survey_id = surveyId;
      this.loadSurveyReport = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/studfbsurveys/${this.survey_id}/report/pdfexport?custom_report=${this.reportType}&individualfiles=${this.singleorindividual == "individual" ? 1 : 0}`;
      this.$axios
        .post(
          url,
          {
            usersubgroup: this.selectedGroupSubgroup != null ? this.selectedGroupSubgroup : null,
          },
          { responseType: "blob" }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          const tempFileName =
            this.singleorindividual == "individual"
              ? "Instructor Feedback Survey (Individual Files).zip"
              : "Instructor Feedback Survey (Single PDF File).pdf";
          link.setAttribute("download", tempFileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.loadSurveyReport = false;
        })
        .catch(() => {
          this.loadSurveyReport = false;
        });
    },

    // placeholder — your code referenced getSubgroupParticipants; include or implement it
    getSubgroupParticipants() {
      // implement if needed
    },
  },
};
</script>
<style scoped>

.usersListPendingFull .modal-dialog {
  max-width: 100%;
  max-height: 100vh;
  margin: 0;
  padding: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  position: fixed !important;
  z-index: 100000;
}

.usersListPendingFull .modal-content {
  border-radius: 0 !important;
  height: 100vh;
  width: 100vw;
}

.usersListPendingFull .modal-body {
  overflow-y: auto;
  height: calc(100vh - 60px);
  /* header height */
}
</style>
